import isEmpty from "is-empty";
import {Collapse} from "@mui/material";
import {Review} from "../../model/types";
import {ProductReviewStars} from "../ProductReviewStars/ProductReviewStars";
import {formatDMY} from "@/shared/lib/date";
import Lightbox from "@/Legacy/all/Lightbox"; //Legacy
import styles from "./ProductReviewItem.module.scss";

type Props = {
    review: Review;
    expanded: Record<number, boolean>;
    onToggleExpand: (id: number) => void;
    numberOfCharacters: number;
}

export const ProductReviewItem = ({review, expanded, onToggleExpand, numberOfCharacters}: Props) => {
    const textLength = review.text?.length ?? 0;

    return (
        <div className={styles.item}>
            <div className={styles.header}>
                <p className={styles.name}>{review.author}</p>
                <p className={styles.date}>{formatDMY(review.created_at)}</p>
                <ProductReviewStars rating={review.rating} />
            </div>
            {review.img && (
                <Lightbox patch={review.img.split('|')} className={`productReviewsPhoto`} />
            )}
            {textLength > 0 && (
                <>
                    <div className={`reviews__content`}>
                        <Collapse in={expanded[review.id]} collapsedSize={20}>
                            <p className={styles.reviewText}>{review.text}</p>
                            <div className={styles.separator}></div>
                            {!isEmpty(review.answer) && (
                                <p className={styles.answerText}>{review.answer}</p>
                            )}
                        </Collapse>
                    </div>
                    {(textLength > numberOfCharacters || !isEmpty(review.answer)) && (
                        <button type={`button`} className={styles.more} onClick={() => onToggleExpand(review.id)}>
                            {expanded[review.id] ? 'Скрыть' : 'Подробнее'}
                        </button>
                    )}
                </>
            )}
        </div>
    );
}
